<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>在贷余额报表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox" v-loading="loading">
                <el-tabs type="border-card" style="width: 100%;">
                    <el-tab-pane label="每日">
                        <el-tabs type="border-card" style="width: 100%;">
                            <div class="listright">
                                <el-table :data="list" height="688"
                                    :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555',}" style="width: 100%">
                                    <el-table-column prop="time" label="统计日期"></el-table-column>
                                    <el-table-column prop="overdue_c" label="逾期_c"></el-table-column>
                                    <el-table-column prop="overdue_7" label="逾期_7"></el-table-column>
                                    <el-table-column prop="overdue_15" label="逾期_15"></el-table-column>
                                </el-table>
                            </div>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane label="每月">
                        <el-tabs type="border-card" style="width: 100%;">
                            <div class="listright">
                                <el-table :data="list1" height="800"
                                    :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555'}" style="width: 100%">
                                    <el-table-column prop="time" label="统计日期"></el-table-column>
                                    <el-table-column prop="overdue_c" label="逾期_c"></el-table-column>
                                    <el-table-column prop="overdue_7" label="逾期_7"></el-table-column>
                                    <el-table-column prop="overdue_15" label="逾期_15"></el-table-column>
                                </el-table>
                            </div>
                        </el-tabs>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
    import dayjs from "dayjs";
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                searchform: {
                    blurry: null,
                    app:"",
                    platform:"",
                },
                loading: false,
                loading1: false,
                list: [],
                list1: [],
                value1:null,
                value2: [
                    dayjs().subtract(7, "month").format("YYYY-MM"), // 起始月份（往前推5个月）
                    dayjs().subtract(1, "month").format("YYYY-MM")
                    //dayjs().format("YYYY-MM") // 当前月份
                ],
                typeList: [],
                platformOptions: [
                    { label: "GraDana", value: "GraDana", app: "Aktivaku" },
                    { label: "AwanTunai", value: "AwanTunai", app: "Aktivaku" },
                    { label: "Aktivaku", value: "Aktivaku", app: "Aktivaku" },
                    { label: "PinjamModal", value: "PinjamModal", app: "Aktivaku" },


                    { label: "IKIModal", value: "IKIModal", app: "Sanders" },
                    { label: "Ethis", value: "Ethis", app: "Sanders" },
                    { label: "Sanders", value: "Sanders", app: "Sanders" },
                    { label: "Akseleran", value: "Akseleran", app: "Sanders" },

                    { label: "Duha", value: "Duha", app: "papitupi" },
                    { label: "komunal", value: "komunal", app: "papitupi" },
                    { label: "papitupi", value: "papitupi", app: "papitupi" },
                    { label: "Ammana", value: "Ammana", app: "papitupi" },

                    { label: "Qazwa", value: "Qazwa", app: "Igrow" },
                    { label: "Restock", value: "Restock", app: "Igrow" },
                    { label: "Igrow", value: "Igrow", app: "Igrow" },
                ]
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getTypeList()
            this.getList()
            this.getList1()
        },
        computed: {
            filteredPlatforms() {
                if (!this.searchform.app) return []; // 默认空
                return this.platformOptions.filter(item => item.app === this.searchform.app);
            }
        },
        methods: {
            onAppChange() {
                this.searchform.platform = null; // 切换 app 时清空子产品
            },
            getNowTime() {
                const now = Date.now();
                const startDate = new Date(now - 8 * 86400000); // 7天前
                const endDate = new Date(now - 1 * 86400000);   // 1天后

                // 本地时间格式化函数
                const formatLocalDate = (date) => {
                    return [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0')
                    ].join('-');
                };

                return [formatLocalDate(startDate), formatLocalDate(endDate)];
            },
           
            getTypeList() {
                _api.get(apiurl.typeList, {
                }).then(res => {
                    this.typeList = res.data
                })
            },
            getList() {
                this.loading = true
                if (this.value1 == null) {
                    this.$message.error(this.$t('tel87'))
                    return
                }
                const type = null; 
                if (this.searchform.blurry != null) {
                    this.type = this.searchform.blurry.join(",")
                }

                this.loading = true
                _api.get(apiurl.loanBalanceDay, {
                    type: this.type,
                    createTime: this.value1,
                    customerType: this.searchform.type,
                    app: this.searchform.app,
                    platform: this.searchform.platform,
                }).then(res => {
                    this.loading = false
                    this.list = res
                })
            },
            getList1() {
                this.loading1 = true
                if (this.value2 == null) {
                    this.$message.error(this.$t('tel87'))
                    return
                }
                const type = null; 
                if (this.searchform.blurry != null) {
                    this.type = this.searchform.blurry.join(",")
                }
                _api.get(apiurl.loanBalanceMoon, {
                    type: this.type,
                    createTime: this.value2,
                    customerType: this.searchform.type,
                    app: this.searchform.app,
                    platform: this.searchform.platform,
                }).then(res => {
                    this.loading = false
                    this.list1 = res
                })
            },
            onSubmit() {
                this.getList()
            },
            onSubmit1() {
                this.getList1()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>